$(document).ready(function(){
      $(".mntn-logos-slider-marquee").slick({
        draggable: false,
        infinite: true,
        autoplay: true,
        arrows: false,
        autoplaySpeed: 0,
        speed: 5000,
        pauseOnHover: false,
        cssEase: 'linear',
        variableWidth: true
      });
})